import { createAction } from 'redux-actions';

import {
  LOAD_TIME_SLOT_LIST,
  LOAD_TIME_SLOT_LIST_SUCCESS,
  LOAD_TIME_SLOT_LIST_ERROR,
  HOLD_BOOKING_SLOT,
  HOLD_BOOKING_SLOT_SUCCESS,
  HOLD_BOOKING_SLOT_ERROR,
  RELEASE_BOOKING_SLOT,
  RELEASE_BOOKING_SLOT_SUCCESS,
  RELEASE_BOOKING_SLOT_ERROR,
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_ERROR,
  SAVE_SELECTED_BOOKING_SLOT,
  SAVE_SELECTED_BOOKING_SLOT_SUCCESS,
  SAVE_SELECTED_BOOKING_SLOT_ERROR,
  CLEAR_SELECTED_BOOKING_SLOT,
  CLEAR_SELECTED_BOOKING_SLOT_SUCCESS,
  CLEAR_SELECTED_BOOKING_SLOT_ERROR,
  LOAD_BOOKING_DETAIL,
  LOAD_BOOKING_DETAIL_SUCCESS,
  LOAD_BOOKING_DETAIL_ERROR,
  RESET_BOOKING_DETAIL,
  LOAD_BOOKING_LIST,
  LOAD_BOOKING_LIST_SUCCESS,
  LOAD_BOOKING_LIST_ERROR,
  RESCHEDULE_BOOKING,
  RESCHEDULE_BOOKING_SUCCESS,
  RESCHEDULE_BOOKING_ERROR,
  CANCEL_BOOKING,
  CANCEL_BOOKING_SUCCESS,
  CANCEL_BOOKING_ERROR,
  UPDATE_BOOKING_INFO,
  UPDATE_BOOKING_INFO_SUCCESS,
  UPDATE_BOOKING_INFO_ERROR,
  RESET_BOOKING_LIST,
  RESET_TIME_SLOT_DATA,
  RESET_CURRENT_HOLDING_SLOT,
} from './type';

//Load time slot list
export const loadTimeSlotListAction = createAction(
  LOAD_TIME_SLOT_LIST,
  payload => payload,
  meta => ({
    client: meta.client,
  }),
);
export const loadTimeSlotListSuccessAction = createAction(
  LOAD_TIME_SLOT_LIST_SUCCESS,
);
export const loadTimeSlotListErrorAction = createAction(
  LOAD_TIME_SLOT_LIST_ERROR,
);

export const holdBookingSlotAction = createAction(HOLD_BOOKING_SLOT);
export const holdBookingSlotSuccessAction = createAction(
  HOLD_BOOKING_SLOT_SUCCESS,
);
export const holdBookingSlotErrorAction = createAction(HOLD_BOOKING_SLOT_ERROR);

export const releaseBookingSlotAction = createAction(RELEASE_BOOKING_SLOT);
export const releaseBookingSlotSuccessAction = createAction(
  RELEASE_BOOKING_SLOT_SUCCESS,
);
export const releaseBookingSlotErrorAction = createAction(
  RELEASE_BOOKING_SLOT_ERROR,
);

export const bookAppointmentAction = createAction(BOOK_APPOINTMENT);
export const bookAppointmentSuccessAction = createAction(
  BOOK_APPOINTMENT_SUCCESS,
);
export const bookAppointmentErrorAction = createAction(BOOK_APPOINTMENT_ERROR);

export const saveSelectedBookingSlotAction = createAction(
  SAVE_SELECTED_BOOKING_SLOT,
);
export const saveSelectedBookingSlotSuccessAction = createAction(
  SAVE_SELECTED_BOOKING_SLOT_SUCCESS,
);
export const saveSelectedBookingSlotErrorAction = createAction(
  SAVE_SELECTED_BOOKING_SLOT_ERROR,
);

export const clearSelectedBookingSlotAction = createAction(
  CLEAR_SELECTED_BOOKING_SLOT,
);
export const clearSelectedBookingSlotSuccessAction = createAction(
  CLEAR_SELECTED_BOOKING_SLOT_SUCCESS,
);
export const clearSelectedBookingSlotErrorAction = createAction(
  CLEAR_SELECTED_BOOKING_SLOT_ERROR,
);

export const loadBookingDetailAction = createAction(LOAD_BOOKING_DETAIL);
export const loadBookingDetailSuccessAction = createAction(
  LOAD_BOOKING_DETAIL_SUCCESS,
);
export const loadBookingDetailErrorAction = createAction(
  LOAD_BOOKING_DETAIL_ERROR,
);
export const resetBookingDetailAction = createAction(RESET_BOOKING_DETAIL);

export const loadBookingListAction = createAction(LOAD_BOOKING_LIST);
export const loadBookingListSuccessAction = createAction(
  LOAD_BOOKING_LIST_SUCCESS,
);
export const loadBookingListErrorAction = createAction(LOAD_BOOKING_LIST_ERROR);

export const rescheduleBookingAction = createAction(RESCHEDULE_BOOKING);
export const rescheduleBookingSuccessAction = createAction(
  RESCHEDULE_BOOKING_SUCCESS,
);
export const rescheduleBookingErrorAction = createAction(
  RESCHEDULE_BOOKING_ERROR,
);

export const cancelBookingAction = createAction(CANCEL_BOOKING);
export const cancelBookingSuccessAction = createAction(CANCEL_BOOKING_SUCCESS);
export const cancelBookingErrorAction = createAction(CANCEL_BOOKING_ERROR);

export const updateBookingInfoAction = createAction(UPDATE_BOOKING_INFO);
export const updateBookingInfoSuccessAction = createAction(
  UPDATE_BOOKING_INFO_SUCCESS,
);
export const updateBookingInfoErrorAction = createAction(
  UPDATE_BOOKING_INFO_ERROR,
);

export const resetBookingListAction = createAction(RESET_BOOKING_LIST);

export const resetTimeSlotDataAction = createAction(RESET_TIME_SLOT_DATA);

export const resetCurrentHoldingSlotAction = createAction(
  RESET_CURRENT_HOLDING_SLOT,
);
